import { Injectable, inject } from '@angular/core'
import { HttpParamsBuilder, Interval, RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Observable } from 'rxjs'
import { environment, isUtilizationTuningEnabled } from '../../../../../environments/environment'
import { FilterBuilder } from '../../../orders/filter-builder'

@Injectable({
  providedIn: 'root',
})
export class ProductionLineAssignmentService extends RestClientList<any, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/assignments', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public optimiseProductionRoutes(
    facilityId: string,
    scheduleInterval: Interval
  ): Observable<unknown> {
    return this.http.post(this.restEndpoint + '/request', null, {
      params: HttpParamsBuilder.start()
        .appendFilter(FilterBuilder.facility(facilityId))
        .appendFilter(FilterBuilder.scheduleInterval(scheduleInterval))
        .build(),
    })
  }

  public evaluateProductionRoutes(
    facilityId: string,
    scheduleInterval: Interval
  ): Observable<unknown> {
    return this.http.post(this.restEndpoint + '/assess', null, {
      params: HttpParamsBuilder.start()
        .appendFilter(FilterBuilder.facility(facilityId))
        .appendFilter(FilterBuilder.scheduleInterval(scheduleInterval))
        .build(),
    })
  }

  /**
   * For development purposes only
   */
  public reset(facility: string, scheduleInterval: Interval): Observable<unknown> {
    {
      if (isUtilizationTuningEnabled()) {
        return this.http.post(`${environment.apiPath}/assignments/reset`, null, {
          params: {
            facility,
            scheduleInterval: scheduleInterval.toString(),
          },
        })
      } else {
        throw Error('Feature not enabled')
      }
    }
  }
}
